import angular, { IScope }  from 'angular';
import { TODO } from '@b2b/types/core/utils';

RemoveAddressModalController.$inject = ['$scope', '$uibModalInstance', 'address'];

function RemoveAddressModalController(
  $scope: IScope & { removeAddressModal: TODO }, 
  $uibModalInstance: TODO, 
  address: TODO
) {
  const ctrl = {
    model: {},
    address: '',
    allowRemove: true,

    init: function () {
      ctrl.model = address;
      ctrl.address = ctrl.process(address);
      if (address.isPrimary) {
        ctrl.allowRemove = false;
      }
    },

    process: function (address) {
      let r = '';

      if (address) {
        if (address.streetAddress1) {
          r += address.streetAddress1;
        }

        if (address.streetAddress2) {
          r += ' ' + address.streetAddress2;
        }

        if (address.city) {
          r += ', ' + address.city;
        }

        if (address.state) {
          r += ', ' + address.state;
        }

        if (address.country) {
          r += ' ' + address.country;
        }

        if (address.zipCode) {
          r += ' ' + address.zipCode;
        }
      }

      return r;
    },

    done: function () {
      if (ctrl.allowRemove) {
        $uibModalInstance.close(ctrl.model);
      } else {
        ctrl.cancel();
      }
    },

    cancel: function () {
      $uibModalInstance.dismiss('cancel');
    },
  };
  $scope.removeAddressModal = ctrl;

  ctrl.init();
}

export const RemoveAddressModalControllerModule = angular
  .module('acme.view.application.partners.create.removeAddressModal.controllers', [])
  .controller('RemoveAddressModalController', RemoveAddressModalController).name;
